module.exports = __webpack_public_path__ + "static/media/pwa.532273b3.svg";